import React from 'react';
import { Link } from 'react-router-dom';
import { operator } from '../features/legal/operator';
import { tr } from '../i18n';
import './PrivacyPolicyPage.css';

const REVISION_DATE = '03.10.2026';

/** Публичная страница политики обработки персональных данных и cookie (152-ФЗ). */
const PrivacyPolicyPage: React.FC = () => {
  const t = tr.shell.privacy;
  return (
    <div className="pvp-page">
      <div className="pvp-header">
        <div className="pvp-kicker">{t.kicker}</div>
        <h1 className="pvp-title">{t.title}</h1>
        <p className="pvp-revision">{t.revision(REVISION_DATE)}</p>
      </div>

      <div className="pvp-body">
        <section className="pvp-section">
          <h2>{t.operator.title}</h2>
          <p>{t.operator.intro(operator.siteUrl)}</p>
          <p>
            {t.operator.contactPrefix}
            <a href={`mailto:${operator.email}`}>{operator.email}</a>
            {t.operator.contactSuffix}
          </p>
        </section>

        <section className="pvp-section">
          <h2>{t.data.title}</h2>
          <ul>
            {t.data.items.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="pvp-section">
          <h2>{t.purposes.title}</h2>
          <ul>
            {t.purposes.items.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="pvp-section">
          <h2>{t.legalBasis.title}</h2>
          <p>{t.legalBasis.text}</p>
        </section>

        <section className="pvp-section">
          <h2>{t.storage.title}</h2>
          <p>{t.storage.text}</p>
        </section>

        <section className="pvp-section">
          <h2>{t.thirdParties.title}</h2>
          <ul>
            <li>
              <strong>{t.thirdParties.valveName}</strong> {t.thirdParties.valveText}
            </li>
            <li>
              <strong>{t.thirdParties.paymentName}</strong> {t.thirdParties.paymentText}
            </li>
            <li>
              <strong>{t.thirdParties.mailName}</strong> {t.thirdParties.mailText}
            </li>
            <li>
              <strong>{t.thirdParties.gameName}</strong> {t.thirdParties.gameText}
            </li>
            <li>
              <strong>{t.thirdParties.hostingName}</strong> {t.thirdParties.hostingText}
            </li>
          </ul>
          <p>{t.thirdParties.noOthers}</p>
        </section>

        <section className="pvp-section">
          <h2>{t.rights.title}</h2>
          <p>{t.rights.lead}</p>
          <ul>
            {t.rights.items.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p>
            {t.rights.requestPrefix} <a href={`mailto:${operator.email}`}>{operator.email}</a>
            {t.rights.requestSuffix}
          </p>
        </section>

        <section className="pvp-section" id="cookies">
          <h2>{t.cookies.title}</h2>
          <p>{t.cookies.text}</p>
          <table className="pvp-cookie-table">
            <thead>
              <tr>
                <th>{t.cookies.columnName}</th>
                <th>{t.cookies.columnPurpose}</th>
                <th>{t.cookies.columnRetention}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label={t.cookies.columnName}>JSESSIONID</td>
                <td data-label={t.cookies.columnPurpose}>{t.cookies.sessionPurpose}</td>
                <td data-label={t.cookies.columnRetention}>{t.cookies.sessionRetention}</td>
              </tr>
              <tr>
                <td data-label={t.cookies.columnName}>rr_refresh_token</td>
                <td data-label={t.cookies.columnPurpose}>{t.cookies.refreshPurpose}</td>
                <td data-label={t.cookies.columnRetention}>{t.cookies.refreshRetention}</td>
              </tr>
            </tbody>
          </table>
          <p>{t.cookies.localStorage}</p>
        </section>

        <section className="pvp-section">
          <h2>{t.changes.title}</h2>
          <p>
            {t.changes.prefix} <Link to="/privacy">{operator.siteUrl}/privacy</Link>
            {t.changes.suffix}
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
